import React from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/data/mock";
import { FadeUp } from "@/components/shared/RevealText";

export default function GallerySection({ compact = false }) {
    const items = compact ? GALLERY.slice(0, 6) : GALLERY;
    return (
        <section className="relative bg-white py-24 md:py-32" data-testid="gallery-section">
            <div className="container-x">
                <div className="mb-16 grid grid-cols-1 items-end gap-8 md:grid-cols-12">
                    <FadeUp className="md:col-span-7">
                        <div className="eyebrow mb-4">Ch. 06 · Gallery</div>
                        <h2 className="h-display font-display text-[40px] font-black leading-[0.95] text-ink md:text-[64px]">
                            Moments,
                            <br />
                            <span className="serif-italic text-pink">recorded</span>.
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1} className="md:col-span-5">
                        <p className="max-w-md text-[15px] leading-relaxed text-slate-600 md:text-[16px]">
                            A living archive of gatherings, dialogues and initiatives — treated as editorial photography,
                            not stock filler.
                        </p>
                    </FadeUp>
                </div>

                <div className="columns-1 gap-6 [column-fill:_balance] sm:columns-2 lg:columns-3">
                    {items.map((g, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.15 }}
                            transition={{ duration: 0.6, delay: (i % 6) * 0.05 }}
                            className="group mb-6 break-inside-avoid overflow-hidden rounded-[22px] border border-ink/10 bg-white"
                            data-testid={`gallery-item-${i}`}
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    src={g.src}
                                    alt=""
                                    style={{ height: g.h, transition: "transform 800ms cubic-bezier(0.22,1,0.36,1)" }}
                                    className="w-full object-cover group-hover:scale-105"
                                    loading="lazy"
                                />
                                <div className="pointer-events-none absolute inset-0 bg-ink/0 transition-colors duration-500 group-hover:bg-ink/10" />
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
